import { faEdit, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import Swal from "sweetalert2";
import SpinnerComponent from "../../../Components/Loding/Spinner";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import {
    DeletarCategoriasRespostaChatController,
    ListarCategoriasRespostaChatController,
} from "../../../Controllers/HelpDesk/GestaoRespostas/GestaoRespostasControllers";
import { ICategorias } from "../../../Interfaces/HelpDesk/GestaoRespostas/GestaoRespostasInterface";
import CadastrarCategoriasRespostaChat from "./ModalCadastrarCategorias";

import EditarCategoriaRespostaChat, {
    EditarCategoriaRespostaChatHeader,
} from "./ModalEditarGestaoRespostas";

export default function GestaoRespostas() {
    const [lstCategorias, setLstCategorias] = useState<Array<ICategorias>>();
    const [modal, setModal] = useState<IComponentModal>();
    const [show, setShow] = useState(false);

    useEffect(() => {
        updateList();
    }, [setLstCategorias]);

    function updateList() {
        ListarCategoriasRespostaChatController().then((res) => {
            setLstCategorias(res);
        });
    }

    function RowTable(cell: any, row: ICategorias) {
        return (
            <>
                <div className="rowCapys">
                    <div>
                        <h4>{row.DS_CATEGORIA_RESPOSTA_CHAT}</h4>
                    </div>
                    <div className="col-tools">
                        <div className="Button-Tools">
                            <button
                                className="btn btn-outline-primary font-weight-bold mr-2"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        customHeader:
                                            EditarCategoriaRespostaChatHeader(
                                                row.DS_CATEGORIA_RESPOSTA_CHAT
                                            ),
                                        Component: () =>
                                            EditarCategoriaRespostaChat({
                                                updateList,
                                                IdCategoria:
                                                    row.ID_CATEGORIA_RESPOSTA_CHAT,
                                            }),
                                        size: "lg",
                                        collapseForm: true,
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} size="lg" />{" "}
                                Editar
                            </button>
                            <button
                                className="btn btn-outline-danger font-weight-bold mr-2"
                                onClick={() => {
                                    Swal.fire({
                                        title: "Deseja apagar esta equipe?",
                                        icon: "info",
                                        buttonsStyling: false,
                                        confirmButtonText:
                                            "<i class='la la-check'></i> Sim!",
                                        showCancelButton: true,
                                        cancelButtonText:
                                            "<i class='la la-thumbs-down'></i> Não",
                                        customClass: {
                                            confirmButton:
                                                "btn btn-outline-success",
                                            cancelButton: "btn btn-default",
                                        },
                                    }).then((result) => {
                                        /* Read more about isConfirmed, isDenied below */
                                        if (result.isConfirmed) {
                                            DeletarCategoriasRespostaChatController(
                                                row.ID_CATEGORIA_RESPOSTA_CHAT
                                            ).then(() => {
                                                updateList();
                                            });
                                        }
                                    });
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />{" "}
                                Excluir
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    const ColunsCategorias: Array<ColumnDescription> = [
        {
            dataField: "DS_CATEGORIA_RESPOSTA_CHAT",
            text: "Categorias",
            formatter: RowTable,
            sort: true,
            isDummyField: true,
        },
    ];

    return lstCategorias !== undefined ? (
        <>
            <div className="card card-custom" id="kt_page_sticky_card">
                <div className="card-header border-0 pt-5">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label font-weight-bolder text-dark">
                            Gestão de Respostas Padrões
                        </span>
                    </h3>
                    <div className="card-toolbar">
                        <button
                            className="btn btn-success font-weight-bold mr-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    Component: () =>
                                        CadastrarCategoriasRespostaChat({
                                            setShow,
                                            updateList,
                                        }),
                                    noFooter: true,
                                    noHeader: true,
                                });
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faPlus}
                                size="lg"
                                className="mr-2"
                            />{" "}
                            Nova Categoria
                        </button>
                    </div>
                </div>
                <div className="card-body pt-2 pb-0 mt-n3">
                    <div className="table-responsive-sm">
                        <Table
                            keyField="ID_CATEGORIA_RESPOSTA_CHAT"
                            data={lstCategorias}
                            columns={ColunsCategorias}
                        />
                    </div>
                </div>
                <ModalComponent
                    show={show}
                    setShow={setShow}
                    ModalComponent={modal}
                />
            </div>
        </>
    ) : (
        <SpinnerComponent />
    );
}
